<template>
    <form-view class="material-preview-view">
        <template slot="field">
            <veui-field label="落地页名称" :tip="store.formData.landingName"/>
            <veui-field label="物料名称" :tip="store.formData.name"/>
            <veui-field label="物料地址" :tip="store.formData.previewUrl"/>
            <veui-field label="预览" :tip="store.formData.phoneType">
                <veui-radio-group :items="items" v-model="picked"/>
                <veui-button ui="link primary" @click="previewMaterial">查看预览</veui-button>
            </veui-field>
            <div class="preview-container">
                <h4>通过手机查看</h4>
                <div class="qrcode-container">
                    <img :src="store.formData.qrCodeUrl" alt="落地页物料预览"/>
                </div>
            </div>
        </template>
        <template slot="operation">
            <veui-button @click="back">返回</veui-button>
        </template>
    </form-view>
</template>
<script>

import FormView from '@baidu/ve-ria/views/FormView';
import {Button, Field, RadioGroup} from 'veui';
import createView from '@baidu/ve-ria/views/createView';
import MaterialPreviewFormModel from './MaterialPreviewFormModel';
import {preview} from '@/common/utils/preview';

export default createView(FormView, MaterialPreviewFormModel, {

    name: 'MaterialPreviewFormView',
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-radio-group': RadioGroup
    },
    data() {
        return {
            items: [
                {
                    label: 'iphone 7',
                    value: 'iphone7'
                },
                {
                    label: 'ihopne 7 Plus',
                    value: 'iphone7Plus'
                }
            ],
            picked: 'iphone7'
        };
    },
    computed: {
        notSupport() {
            return /MSIE|Trident|Edge|Firefox/i.test(navigator.userAgent);
        }
    },
    methods: {
        previewMaterial() {
            const params = this.picked === 'iphone7' ? {width: 375, height: 667} : {width: 414, height: 736};
            preview({
                ...params,
                title: '落地页物料预览',
                src: this.store.formData.previewUrl
            });
        }
    }
});
</script>
<style lang="less">
@import "~@/common/css/variables.less";
.material-preview-view {
    font-size: 14px;

    .preview-container {
        margin-left: 120px;

        h4 {
            color: #000;
        }

        .qrcode-container {
            width: 160px;
            height: 160px;
            padding: 10px;
            margin: 10px auto;
            border-radius: 4px;
            display: inline-block;
            border: 1px solid @muses-gray-2;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .form-operation {
        margin-top: 30px;
    }
}
</style>


